import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { Loading, ShippingDetails, Text } from '@reveni-io/reveni-ui'

import RMAContext from '@/returns/pages/TransactionRMAPage/context/RMAContext'

const ReturnDetails = ({ loading }) => {
  const { rmaInfo } = useContext(RMAContext)
  const { t } = useTranslation()

  return (
    <Loading show={loading} height="150px">
      <Text type="titleS">{t('Detalles devolución')}</Text>
      {rmaInfo?.orderInfo?.deliveryMethod ? (
        <ShippingDetails
          deliveryMethod={rmaInfo?.orderInfo?.deliveryMethod}
          shippingAddress={rmaInfo?.orderInfo?.shipping_address}
          numberOfReturnLabels={rmaInfo?.numberOfReturnLabels}
        />
      ) : (
        <Text type="bodyMRegular">{t('Ningún método de devolución seleccionado')}</Text>
      )}
    </Loading>
  )
}

export default ReturnDetails
